import {AppActionType} from "../../const/actionType";

export function setUserInfo(value) {
  // ConsoleLog("setUserInfo", value);
  return {type: AppActionType.SET_USER, value};
}

export function setAuthToken(value) {
  // ConsoleLog("setAuthToken", value);
  return {type: AppActionType.SET_AUTH_TOKEN, value};
}

export function setAvailableMenu(value) {
  // ConsoleLog("setAvailableMenu", value);
  return {type: AppActionType.SET_MENU, value};
}

export function logout() {
  // ConsoleLog("setUserInfo", value);
  return {type: AppActionType.LOGOUT};
}

export function setSwVersion(value) {
  // ConsoleLog("setUserInfo", value);
  return {type: AppActionType.SET_SW_VERSION, value};
}

export function setCurrentPeriodId(value) {
  return {type: AppActionType.SET_CURRENT_PERIOD_ID, value};
}

export const setIsSavingReview = (isSavingReview) => ({
  type: AppActionType.SET_IS_SAVING_REVIEW,
  isSavingReview,
});

export const setConsolidationStatus = (value) => ({
  type: AppActionType.SET_CONSOLIDATION_STATUS,
  value,
})